export default {
  AppName: 'Barbanet',
  AppTagline: 'Admin dashboard'
}
